// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2F6Go","header":"MergedInvoice_header__BReAW"};